import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './CallExpertPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CallExpertPage = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', phone: '', crop: '', details: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const envApiUrl = process.env.REACT_APP_API_URL?.trim();
  const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Re-using the contact API with specific subject
      // In a real scenario, email might be required by backend, so we pass a dummy if missing
      const response = await fetch(`${API_URL}/leads/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          email: form.phone + '@expert.com', // backend validation requires email
          phone: form.phone,
          subject: 'Call Expert Request - ' + form.crop,
          message: form.details || 'I need expert guidance on choosing equipment.'
        })
      });
      if (response.ok) {
        alert(t('call_expert_page.success_msg'));
        setForm({ name: '', phone: '', crop: '', details: '' });
      } else {
        alert(t('call_expert_page.fail_msg'));
      }
    } catch (error) {
      alert(t('call_expert_page.error_msg'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="call-expert-page">
      <Header />
      <div className="expert-top-bar"></div>
      
      <section className="expert-hero">
        <div className="container">
          <h1 className="expert-title">{t('call_expert_page.title')}</h1>
          <p className="expert-subtitle">{t('call_expert_page.subtitle')}</p>
        </div>
      </section>

      <section className="expert-main">
        <div className="container">
          <div className="expert-grid">
            <div className="expert-info-card">
              <h2 className="card-heading">{t('call_expert_page.why_consult')}</h2>
              <div className="info-row">
                <div className="info-icon green">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                </div>
                <div>
                  <strong>{t('call_expert_page.right_match_title')}</strong>
                  <p>{t('call_expert_page.right_match_desc')}</p>
                </div>
              </div>
              <div className="info-row">
                <div className="info-icon orange">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                </div>
                <div>
                  <strong>{t('call_expert_page.quick_call_title')}</strong>
                  <p>{t('call_expert_page.quick_call_desc')}</p>
                </div>
              </div>
              
              <div className="info-row">
                <div className="info-icon green">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                </div>
                <div>
                  <strong>{t('call_expert_page.available_bihar_title')}</strong>
                  <p>{t('call_expert_page.available_bihar_desc')}</p>
                </div>
              </div>
            </div>

            <div className="expert-form-card">
              <h2 className="card-heading">{t('call_expert_page.request_call')}</h2>
              <form onSubmit={handleSubmit} className="expert-form">
                <input type="text" name="name" placeholder={t('call_expert_page.name_ph')} value={form.name} onChange={handleChange} required className="form-input" />
                <input type="tel" name="phone" placeholder={t('call_expert_page.phone_ph')} value={form.phone} onChange={handleChange} required pattern="[0-9]{10}" title="Please enter 10 digit mobile number" className="form-input" />
                <input type="text" name="crop" placeholder={t('call_expert_page.crop_ph')} value={form.crop} onChange={handleChange} required className="form-input" />
                <textarea name="details" placeholder={t('call_expert_page.details_ph')} value={form.details} onChange={handleChange} rows={4} className="form-textarea"></textarea>
                <button type="submit" className="btn-send" disabled={loading}>
                  {loading ? t('call_expert_page.btn_submitting') : t('call_expert_page.btn_submit')}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default CallExpertPage;


